export default __webpack_public_path__ + "static/media/highly-realistic-designs.692068ac.svg";